import { render } from "./About.vue?vue&type=template&id=0220bedf&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=0220bedf&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0220bedf"]])

export default __exports__